import * as React from 'react';
import workflowsPlatformAndroidMdm from '../../../../assets/workflows-platform-android-mdm.svg';

/**
 * TEMPORARY: DoorDash hubble-kiosk-react-native-ota MDM branding override.
 * Delete this file (and its call sites) when no longer needed.
 */
export function getTemporaryPlatformDisplayOverride(
    orgId: string | null | undefined,
    app: { appId?: string } | null | undefined,
): { label: string; icon: (size: number) => React.ReactNode } | null {
    if (orgId !== 'doordash' || app?.appId !== 'hubble-kiosk-react-native-ota') {
        return null;
    }
    return {
        label: 'MDM',
        icon: (size) => (
            <img src={workflowsPlatformAndroidMdm} width={size} height={size} style={{ flexShrink: 0 }} alt="" />
        ),
    };
}
